module.exports = __webpack_public_path__ + "img/idcardy.08b96214.png";